import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Moon, MapPin, Clock } from 'lucide-react';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
import { getPlacesByCategory } from '../data/places';
export function NightlifePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const nightlifeSpots = getPlacesByCategory('Nightlife');
  return <div className="min-h-screen bg-white" data-id="element-1274">
      {/* Hero */}
      <div className="border-b border-gray-100" data-id="element-1275">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-24" data-id="element-1276">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl" data-id="element-1277">
            <div className="inline-flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full mb-6" data-id="element-1278">
              <Moon className="w-4 h-4 text-gray-600" strokeWidth={2} data-id="element-1279" />
              <span className="text-sm font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1280">
                After Dark
              </span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight tracking-tight" data-id="element-1281">
              Nairobi Nightlife
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1282">
              From upscale lounges to vibrant clubs, discover where Nairobi
              comes alive after sunset with world-class entertainment and
              unforgettable experiences.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-1283">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1284">
          {nightlifeSpots.map((spot, index) => <motion.div key={spot.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-1285">
              <Link to={`/place/${spot.id}`} className="block group" data-id="element-1286">
                <div className="border-2 border-gray-100 hover:border-gray-300 transition-all overflow-hidden h-full flex flex-col" data-id="element-1287">
                  {/* Image */}
                  <div className="relative aspect-[4/3] overflow-hidden" data-id="element-1288">
                    <img src={spot.image} alt={spot.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1289" />
                  </div>

                  {/* Content */}
                  <div className="p-6 flex-1 flex flex-col" data-id="element-1290">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:underline" data-id="element-1291">
                      {spot.name}
                    </h3>

                    <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1" data-id="element-1292">
                      {spot.description}
                    </p>

                    <div className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-1293">
                      <div className="flex items-center gap-2" data-id="element-1294">
                        <MapPin className="w-4 h-4" strokeWidth={2} data-id="element-1295" />
                        <span data-id="element-1296">{spot.location}</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-1297">
                        <Clock className="w-4 h-4" strokeWidth={2} data-id="element-1298" />
                        <span data-id="element-1299">{spot.info.hours}</span>
                      </div>
                    </div>

                    <div className="pt-4 border-t border-gray-100" data-id="element-1300">
                      <span className="text-sm font-semibold text-gray-900 group-hover:underline" data-id="element-1301">
                        View details →
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>

      <ScrollToTop data-id="element-1302" />
      <Footer data-id="element-1303" />
    </div>;
}